<template>
  <component
    :is="clickable ? 'button' : 'div'"
    :type="clickable ? 'button' : undefined"
    class="bg-background-neutral-onblock flex w-full items-center gap-2 rounded-xl px-3 py-3 text-left"
    @click="onClick"
  >
    <WarningIcon class="size-5 shrink-0" />
    <p class="text-text-neutral-primary flex-1 text-xs">
      {{ title }}
    </p>
    <ChevronIcon
      v-if="clickable"
      :width="16"
      :height="16"
      class="text-text-neutral-quaternary shrink-0"
    />
  </component>
</template>

<script setup lang="ts">
  import WarningIcon from '../../../../assets/images/smart-route/warning.svg?component';
  import ChevronIcon from '../../../../assets/images/chevron-arrow.svg?component';

  const props = defineProps<{
    title: string;
    clickable?: boolean;
  }>();

  const emit = defineEmits<{ onClick: [] }>();

  const onClick = () => {
    if (props.clickable) {
      emit('onClick');
    }
  };
</script>
